import { reactive } from 'vue';

export const criarPessoa = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        identidade: 0,
        cdpessoa: 0,
        nmpessoa: '',
        cpfcnpj: '',
        ie: 0,
        endereco: '',
        nmendereco: 0,
        complemento: '',
        nmbairro: '',
        cep: '',
        nmmunicipio: '',
        uf: '',
        fone: '',
        email: '',
        login: '',
        senha: '',
        dtsenha: '',
        dtnascimento: '',
        ckativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
};